module.exports = "/_next/static/images/img__main-5315d539388bd337b07f8d0a9fc8a332.png";